import { render, staticRenderFns } from "./PageOverlay.vue?vue&type=template&id=5e05f212&scoped=true"
import script from "./PageOverlay.vue?vue&type=script&lang=js"
export * from "./PageOverlay.vue?vue&type=script&lang=js"
import style0 from "./PageOverlay.vue?vue&type=style&index=0&id=5e05f212&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e05f212",
  null
  
)

export default component.exports